import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { SnackbarProvider } from 'notistack';

import {
    CssBaseline,
    ThemeProvider,
    TSLTheme,
} from '@thirdspacelearning/library';
import { AuthProvider } from '@tsl-frontend/tsl-keycloak-auth';
import { MaintenanceProvider } from '@tsl-frontend/tsl-maintenance';

import App from './app/App';
import { store } from './store';

import { LaunchDarklyProvider } from '@hooks';
import { queryClient } from '@services';
import { CurriculumSnackbar } from '@shared';
import { environment } from '@environments/environment';

const root = createRoot(document.getElementById('root')!);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <AuthProvider
                keycloakUrl={environment.keycloakUrl}
                keycloakRealm={environment.keycloakRealm}
                keycloakClientId={environment.keycloakClientId}
            >
                <LaunchDarklyProvider>
                    <ThemeProvider theme={TSLTheme}>
                        <CssBaseline />
                        <QueryClientProvider client={queryClient}>
                            <SnackbarProvider
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                Components={{
                                    curriculumSnackbar: CurriculumSnackbar,
                                }}
                                autoHideDuration={3000}
                                preventDuplicate={true}
                            />
                            <Router>
                                <MaintenanceProvider>
                                    <App />
                                </MaintenanceProvider>
                            </Router>
                        </QueryClientProvider>
                    </ThemeProvider>
                </LaunchDarklyProvider>
            </AuthProvider>
        </Provider>
    </React.StrictMode>,
);
